<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form
          class="box"
          ref="supplierForm"
          :model="supplier"
          label-width="70px"
        >
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('user.name')">
                  {{ supplier.name }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('user.phone')">
                  {{ supplier.phone }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" v-if="supplier.url != null">
                <el-form-item :label="$t('supplier.url')">
                  {{ supplier.url }}
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("customer.addressInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.province')">
                  {{ supplier.province }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.city')">
                  {{ supplier.city }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.address')">
                  {{ supplier.address }}
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset v-if="supplier.remark != null" class="mgb15">
            <legend>{{ $t("text.remark") }}</legend>
            <raw-html :content="supplier.remark"></raw-html>
          </fieldset>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import RawHtml from "@/components/RawHtml";
import Supplier from "@/api/supplier.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtml,
  },
  data() {
    return {
      supplier: {},
      users: [],
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    Supplier.findById(self.id).then(function (res) {
      if (res.data.code === 200) {
        self.supplier = res.data.entity;
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {},
};
</script>